export default __webpack_public_path__ + "static/media/GHSI Internal Audit Charter.ccfb2209.pdf";